import React from 'react';
import {
  Alert, Box, Button, Card, CardContent, Skeleton, Stack, Typography,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { errorText } from '../utils/format';

function ListSkeleton({ rows = 4 }) {
  return (
    <Stack spacing={1.5} data-testid="loading-skeleton">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} variant="rounded" height={64} />
      ))}
    </Stack>
  );
}

export function EmptyState({
  icon, title, body, action,
}) {
  return (
    <Card>
      <CardContent sx={{ textAlign: 'center', py: 6 }}>
        {icon && <Box sx={{ color: 'primary.main', mb: 1 }}>{icon}</Box>}
        <Typography variant="h6" gutterBottom>{title}</Typography>
        {body && (
          <Typography color="text.secondary" sx={{ maxWidth: 480, mx: 'auto', mb: action ? 2.5 : 0 }}>
            {body}
          </Typography>
        )}
        {action}
      </CardContent>
    </Card>
  );
}

/**
 * Shows skeletons while loading, a retryable error, a permission message for 403, an empty state,
 * or the children.
 */
export default function StateBoundary({
  loading, error, onRetry, isEmpty, empty, rows, children,
}) {
  if (loading) return <ListSkeleton rows={rows} />;
  if (error) {
    if (error.status === 403) {
      return (
        <EmptyState
          icon={<LockOutlinedIcon fontSize="large" />}
          title="You do not have access"
          body={errorText(error)}
        />
      );
    }
    return (
      <Alert
        severity="error"
        action={onRetry && <Button color="inherit" size="small" onClick={() => onRetry()}>Retry</Button>}
      >
        {errorText(error)}
      </Alert>
    );
  }
  if (isEmpty && empty) return <EmptyState {...empty} />;
  return children;
}
